import React, { useRef, useEffect } from 'react';

import iframeResizerRaw from 'iframe-resizer';

const iframeResizer = (iframeResizerRaw as any).iframeResizer || iframeResizerRaw;

const RevExIFrame: React.FC = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (iframeRef.current) {
      iframeResizer(
        {
          checkOrigin: false,
          log: false,
          license: 'GPLv3', // Added temporary license key
          heightCalculationMethod: 'taggedElement',
        },
        iframeRef.current
      );
    }
  }, []);

  return (
    <div className="iFrame-container" 
      style={{
        borderRadius: '8px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
        width: '100%',
        minHeight: '85vh', 
        overflowX: 'hidden',
    }}>
      <iframe
        ref={iframeRef}
        src="https://old.transparent.utah.gov/state_rvex_highlight.php"
        style={{ width: '1px', minWidth: '100%', border: 'none' }}
        title="Utah Revenue/Expenditure"
      />
    </div>
  )
}

export default RevExIFrame;